import {createFileRoute} from '@tanstack/react-router'
import ContactPage from "../landing/ContactPage.tsx";

export const Route = createFileRoute('/contact')({
    component: RouteComponent,
})

function RouteComponent() {
    return <ContactPage />
}
